module.exports = __webpack_public_path__ + "img/approved.8e4e2d53.svg";